import styled from "styled-components";
import { BreadcrumbContainer } from "../Breadcrumb/styles";
import { Subtitle } from "../../settings/layout";

export const PageHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 35px;

    ${BreadcrumbContainer} {
        margin-bottom: 10px;
    }

    ${Subtitle} {
        margin-top: 10px;
    }
`;
